// NOTE: Sync with apps/portal/src/types/shipments.ts and then replace?
import { fallback } from '@tanstack/zod-adapter';
import z from 'zod';

export const ShipmentsSearchStatusesSchema = z.enum([
	'UNKNOWN',
	'PUBLISHED',
	'QUOTED',
	'CARRIER_ASSIGNED',
	'EXECUTED',
	'COMPLETED',
	'CANCELLED',
	'CONCEPT',
	'COST_DECLARED',
]);

type ShipmentsSearchStatuses = z.infer<typeof ShipmentsSearchStatusesSchema>;

const SHIPMENTS_SEARCH_DEFAULT_PAGE = 0;
const SHIPMENTS_SEARCH_DEFAULT_SIZE = 20;
const SHIPMENTS_SEARCH_DEFAULT_SORT_BY = 'SHIPMENT_NUMBER';
const SHIPMENTS_SEARCH_DEFAULT_SORT_ORDER = 'ASC';
export const SHIPMENTS_SEARCH_DEFAULT_STATUSES_PUBLISHED: ShipmentsSearchStatuses[] =
	['PUBLISHED', 'QUOTED'];
export const SHIPMENTS_SEARCH_DEFAULT_STATUSES_ASSIGNED: ShipmentsSearchStatuses[] =
	['CARRIER_ASSIGNED', 'COST_DECLARED', 'EXECUTED'];
export const SHIPMENTS_SEARCH_DEFAULT_STATUSES_DRAFTED: ShipmentsSearchStatuses[] =
	['CONCEPT'];
export const SHIPMENTS_SEARCH_DEFAULT_STATUSES_ARCHIVED: ShipmentsSearchStatuses[] =
	['CANCELLED', 'COMPLETED'];

const BaseShipmentsSearchSchema = z.object({
	page: fallback(z.coerce.number(), SHIPMENTS_SEARCH_DEFAULT_PAGE).default(
		SHIPMENTS_SEARCH_DEFAULT_PAGE,
	),
	size: fallback(z.coerce.number(), SHIPMENTS_SEARCH_DEFAULT_SIZE).default(
		SHIPMENTS_SEARCH_DEFAULT_SIZE,
	),
	sortBy: fallback(
		z.enum(['SHIPMENT_NUMBER']),
		SHIPMENTS_SEARCH_DEFAULT_SORT_BY,
	).default(SHIPMENTS_SEARCH_DEFAULT_SORT_BY),
	sortOrder: fallback(
		z.enum(['ASC', 'DESC']),
		SHIPMENTS_SEARCH_DEFAULT_SORT_ORDER,
	).default(SHIPMENTS_SEARCH_DEFAULT_SORT_ORDER),
	'filter.transportTypes': z
		.enum(['IMPORT', 'EXPORT', 'SHUNT', 'OTHER'])
		.array()
		.optional(),
	'filter.containerSizes': z
		.enum([
			'UNKNOWN',
			'SIZE_20FT',
			'SIZE_30FT',
			'SIZE_40FT',
			'SIZE_45FT',
			'OTHER',
		])
		.array()
		.optional(),
	'filter.fromDateTime': z.string().optional(),
	'filter.untilDateTime': z.string().optional(),
	'filter.userIds': z.number().array().optional(),
	'filter.requirements': z.string().array().optional(),
	'filter.onlyContractShipments': z.boolean().optional(),
});

export const ShipmentsSearchSchema = BaseShipmentsSearchSchema.extend({
	'filter.statuses': ShipmentsSearchStatusesSchema.array().optional(),
	'filter.countries': z.string().array().optional(),
	'filter.shippingLines': z.string().array().optional(),
	'filter.cocStatus': z
		.enum(['NONE', 'PENDING', 'DECLINED'])
		.array()
		.optional(),
	'filter.groups': z.number().array().optional(),
	'filter.carrierAssignedSubStatus': z
		.enum(['OPEN', 'IN_PROGRESS'])
		.array()
		.optional(),
});

export const GroupedShipmentsSearchSchema = BaseShipmentsSearchSchema;
